export default "__VITE_ASSET__2f690b96__"